// Ensure jQuery is available globally for legacy plugins
import $ from 'jquery';
window.$ = window.jQuery = $;

// Bootstrap 5 (JS only, CSS handled in main.scss)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Font Awesome 6 (With v4 backward compatibility shims)
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/css/v4-shims.min.css';

// Slick Carousel
import 'slick-carousel/slick/slick.min.js';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Bootstrap Select
import 'bootstrap-select/dist/js/bootstrap-select.min.js';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';

// Load your custom project styles and scripts
import './styles/main.scss';
import './scripts/main.js';